module.exports = __webpack_public_path__ + "static/img/course-teach.b7d7aa3d.png";